import camelCase from 'lodash/camelCase';
import { NCNotification } from '../../types/nc';

/**
 * Checks that every field is defined in the message.
 * Field name can be simple or nested: 'originator', 'subject.comment'
 */
function checkFields(notification: NCNotification, ...fields: string[]) {
  return fields.every(field => {
    let object = notification;
    const parts = field.split('.');
    for (const part of parts) {
      if (object[part] === undefined || object[part] === null) {
        return false;
      }
      object = object[part];
    }
    return true;
  });
}

export function isValidNotification(notification: NCNotification) {
  if (
    !notification ||
    !notification.type ||
    !notification.messageId ||
    !notification.messageData ||
    notification.orphaned
  ) {
    return false;
  }
  const key = notification.messageData.dataKey;
  if (!key) {
    return false;
  }
  const camelized = camelCase(key);
  if (!notification.messageData[camelized]) {
    return false;
  }
  switch (notification.type) {
    case 'nc.commission_receipt':
    case 'nc.commission_request':
      return checkFields(
        notification,
        'messageData.correspondence.bppModule.commissionRequest.bppInstigator',
        'messageData.correspondence.bppModule.commissionRequest.commission'
      );
    case 'nc.originals_order':
    case 'nc.originals_order_receipt':
      return checkFields(
        notification,
        'messageData.correspondence.bppModule.originalsOrder.bppInstigator',
        'messageData.correspondence.bppModule.originalsOrder.deviation.originals'
      );
    case 'nc.originals_delivery':
    case 'nc.originals_delivery_receipt':
      return checkFields(
        notification,
        'messageData.correspondence.bppModule.originalsDelivery.bppInstigator',
        'messageData.correspondence.bppModule.originalsDelivery.originals'
      );
    default:
  }
  return true;
}
